module.exports = __webpack_public_path__ + "fonts/font.4d025d4.woff";